import React from "react";
import { createImageFromInitials } from "../AgentLogo";
import { Product, Sources } from "../constants";
import Avatar from "../static/images/tia.png";
import HealthChatHeader from "./Health/ChatHeader";
import TravelChatHeader from "./Travel/ChatHeader";
import ServiceChatHeader from "./ServiceBot/ChatHeader";
import HomeChatHeader from "./Home/ChatHeader";
import TermChatHeader from "./Term/ChatHeader";
import TermLifeChatHeader from "./TermLife/ChatHeader";
//import InvestmentChatHeader from "./Investment/ChatHeader";
import InvestmentChatHeader from "./Investmentv1/ChatHeader";
import MotorChatHeader from "./Motor/ChatHeader";
import TwoWheelerHeader from "./TwoWheeler/ChatHeader";
export default function ChatHeader({ showVideoCallButton, empId , agentName, showModal, messageCounter, botName, GAEvent, productId, isService, closeChat, roomClosed, source, sendMessage, setTabHasFocus, mobileClass,newTermUi , ticketRatingDone, clearRoomData}) {
  const miniMize = (e) => {
    // e.preventDefault();
    console.log("minimizing ini");
    if (window && window.parent) {
      console.log("minimizing start");
      setTabHasFocus(false);
      if(productId === Product.Investment && !isService){
        window.parent.postMessage({ message: 'Box minimize.', investmentChatMinimize: true }, '*');
      }else{
        window.parent.postMessage({ message: 'Box minimize.', minimize: true }, '*');
      }
      
      removeFocusFromInput()
    } else {
      console.log("minimizing not  start");
    }
    GAEvent({ eventAction: "Chat-Minimizes", eventLabel: "Click-Chat-Minimizes" })
  }
  function removeFocusFromInput() {
   
      document.activeElement.blur();

  }
  

  return (
    <>
      {productId === Product.Health && !isService ?
        <HealthChatHeader
          miniMize={miniMize}
          agentName={agentName}
          showModal={showModal}
          messageCounter={messageCounter}
          botName={botName}
          mobileClass={mobileClass} />
        : null}
      {productId === Product.Travel && !isService ?
        <TravelChatHeader
          miniMize={miniMize}
          agentName={agentName}
          showModal={showModal}
          messageCounter={messageCounter}
          botName={botName} />
        : null}
      {productId === Product.Investment && !isService ?
        <InvestmentChatHeader
          miniMize={miniMize}
          agentName={agentName}
          showModal={showModal}
          messageCounter={messageCounter}
          botName={botName} />
        : null}
      {isService && source !== Sources.POST_PAYMENT_CAR_CJ ?
        <ServiceChatHeader
          miniMize={miniMize}
          agentName={agentName}
          showModal={showModal}
          messageCounter={messageCounter}
          botName={botName}
          closeChat={closeChat}
          roomClosed={roomClosed}
          source={source} 
          sendMessage={sendMessage}
          productId={productId}
          ticketRatingDone={ticketRatingDone}
          clearRoomData={clearRoomData}
          />
        : null}
      {productId === Product.Home && !isService ?
        <HomeChatHeader
          miniMize={miniMize}
          agentName={agentName}
          showModal={showModal}
          messageCounter={messageCounter}
          botName={botName} />

        : null}
        {productId === Product.Term && !isService && newTermUi ?
          <TermLifeChatHeader
            miniMize={miniMize}
            agentName={agentName}
            empId={empId}
            showModal={showModal}
            messageCounter={messageCounter}
            botName={botName}
            showVideoCallButton={showVideoCallButton}
            roomClosed={roomClosed} />
        
        : null}
        {productId === Product.Term && !isService && !newTermUi ?
        <TermChatHeader
          miniMize={miniMize}
          agentName={agentName}
          showModal={showModal}
          messageCounter={messageCounter}
          botName={botName} />  
        : null}
        
        {((productId === Product.Motor || productId === Product.CommercialVehicle) && !isService ) || (productId === Product.Motor && source == Sources.POST_PAYMENT_CAR_CJ )  ?
        <MotorChatHeader
        miniMize={miniMize}
        agentName={agentName}
        showModal={showModal}
        messageCounter={messageCounter}
        botName={botName}
        closeChat={closeChat}
        roomClosed={roomClosed}
        source={source} 
        sendMessage={sendMessage}
        productId={productId} />

        : null}
        {productId === Product.Twowheeler && !isService ?
        <TwoWheelerHeader
          miniMize={miniMize}
          agentName={agentName}
          showModal={showModal}
          messageCounter={messageCounter}
          botName={botName} />
        : null}
    </>
  );
}
